import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FileViewerManagerService} from '../../../../Services/Shared/file-viewer-manager.service';
import {FileInputAsset} from '../../../../Models/Shared/file-input-asset.model';
import {ImageAsset} from '../../../../Models/Shared/image-asset.interface';

@Component({
  selector: 'app-yu-file-item',
  templateUrl: './yu-file-item.component.html',
  styleUrls: ['./yu-file-item.component.scss'],
  standalone: false,
})
export class YuFileItemComponent {

  @Input() file: FileInputAsset | ImageAsset | null = null;
  @Input() labelFile: string = '';

  @Input() labelButton: string = '';
  @Input() disabledButton: boolean = false;
  @Output() clickButton: EventEmitter<void> = new EventEmitter<void>();

  @Input() canRemove: boolean = false;
  @Output() fileRemoved: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public fileViewerManager: FileViewerManagerService,
  ) {
  }


  /**
   * Mostrar archivo
   *
   */
  openFile() {

    if (!this.file) {
      return;
    }

    this.fileViewerManager.openFile(this.file.url, this.file.extension);
  }

}
